
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 14.9 15.2","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M9.8 2.9L6.9.3C6.8.2 6.5 0 6.2 0H1.4C.6 0 0 .6 0 1.4v9.8c0 .8.6 1.4 1.4 1.4h1.2v-1.1H1.4c-.2 0-.3-.2-.3-.3V1.4c0-.2.2-.3.3-.3h4.3v1.6c0 1 .8 1.8 1.8 1.8H10v-.8c0-.4-.1-.6-.2-.8zm-2.9-.2v-.9l1.8 1.6h-1c-.5 0-.8-.3-.8-.7z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M14.8 8.6l-3.2-3.8c-.2-.2-.5-.3-.8-.1-.2.2-.3.5-.1.8l.1.1-3.4.5c-.5.1-.8.4-1 .7l-2.9 6.7c-.2.4-.1.9.2 1.2.2.3.6.4.9.4h.3l6.9-1.7c.4-.1.7-.4.8-.7L14 9.3c.1.1.2.2.4.2.1 0 .3 0 .4-.1.2-.3.2-.6 0-.8zm-3.2 3.8l-6 1.5 3-2.5c.2.1.3.1.5.1.8 0 1.4-.6 1.4-1.4s-.7-1.4-1.4-1.4-1.4.6-1.4 1.4c0 .2 0 .3.1.5L5 12.9l2.4-5.6.1-.1 3.8-.6 1.8 2.1-1.5 3.7zm-2.8-2.3c0-.2.1-.3.3-.3s.3.1.3.3c0 .2-.1.3-.3.3s-.3-.2-.3-.3z"}})])
          )
        }
      }
    